import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ExcludeDescriptionCatalog, StringConst } from 'src/app/constants/const';
import { BBVACard, DeleteCardReq } from 'src/app/model/http/bbva.model';
import { BBVAPaymentsService } from 'src/app/services/bbvapayments.service';
import { DialogService } from 'src/app/services/dialog.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ConfirmDeleteCardComponent } from '../confirm-delete-card/confirm-delete-card.component';

@Component({
  selector: 'app-bbva-cards',
  templateUrl: './bbva-cards.component.html',
  styleUrls: ['./bbva-cards.component.scss']
})
export class BbvaCardsComponent implements OnInit {

  cardIdSelected = StringConst.empty;
  cards: BBVACard[] = [];
  constructor(
    private matDialogRef: MatDialogRef<BbvaCardsComponent>,
    private bbvaService: BBVAPaymentsService,
    private dialogService: DialogService,
    private localStorageService: LocalStorageService) { }

  ngOnInit(): void {
    this.getCards(true);
  }

  getCards(setFirst: boolean): void {
    const cardCode = this.localStorageService.getCardCodeGeneral();
    this.bbvaService.getCards(cardCode).subscribe((res) => {
      this.cards = res.response ?? [];
      if (this.cards.length > 0 && setFirst) {
        this.cardIdSelected = this.cards[0].tokenId;
      }
    });
  }
  selectCard(card: BBVACard): void {
    this.cardIdSelected = card.tokenId;
  }
  useCard(): void {
    this.matDialogRef.close(this.cardIdSelected);
  }
  newCard(): void {
    this.matDialogRef.close(ExcludeDescriptionCatalog.noApplyLabel);
  }

  deleteCard(card: BBVACard): void {
    this.dialogService.displayDialog(ConfirmDeleteCardComponent, {
      data: card.lastDigits
    }).afterClosed().subscribe(res => {
      if (res) {
        this.delete(card);
      }
    });
  }

  delete(card: BBVACard): void {
    const req = new DeleteCardReq();
    req.cardCode = this.localStorageService.getCardCodeGeneral();
    req.cardId = card.tokenId;
    this.bbvaService.deleteCard(req).subscribe(() => {
      const selected = card.tokenId === this.cardIdSelected;
      this.cardIdSelected = selected ? StringConst.empty : this.cardIdSelected;
      this.getCards(selected);
    });
  }
}
